import { Outlet } from "react-router";
import { preload } from "react-dom";
import Navbar from "./Navbar";
import axios from 'axios';
//import { devprojects, devabout } from './dummyvalues';
import { useState, useEffect } from 'react';

export default function Wrapper() {
  const [projects, setProjects] = useState([]);
  const [about, setAbout] = useState("");

  useEffect(() => {
    axios.get(( window.API_ENDPOINT || "/api/" )+"projects")
        .then(res => {
            setProjects(res.data);
        })
    axios.get(( window.API_ENDPOINT || "/api/" )+"about")
      .then(res => {
          setAbout(res.data);
      })
  }, []);

  if (projects) {
    let src = projects.sort(function(a,b){ return new Date(b.date) - new Date(a.date); })[0]?.Sources?.split(";")?.[0];
    if (src) preload("/assets/images/"+src, {
        as: "image",
    });
  }

  return (
    <>
      <Navbar projects={projects}>
        <Outlet context={{projects, about}} />
      </Navbar>
    </>
  )
}